import moment from 'moment';
import 'moment/locale/es';
import PropTypes from 'prop-types';
import React from 'react';
import { Modal } from 'react-bootstrap';
import { FiEdit } from 'react-icons/fi';
import { EditMatriculadoForm } from '../forms/EditMatriculadoForm';
import { useDispatch } from 'react-redux';
import { setEditModalId } from 'redux/matriculadosSlice';
moment.locale('es');

const EditMatriculadoModal = ({ modalShow }) => {
  const dispatch = useDispatch();
  return (
    <Modal
      show={modalShow}
      onHide={() => {
        dispatch(setEditModalId(null));
      }}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-lg"
    >
      <Modal.Header closeButton>
        <Modal.Title className="fw-light">
          <FiEdit /> Editar Matriculado
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <EditMatriculadoForm />
      </Modal.Body>
    </Modal>
  );
};

EditMatriculadoModal.propTypes = {
  modalShow: PropTypes.bool.isRequired
};

export default EditMatriculadoModal;
